/**
 * Que campos sirven para colocar filas en el tiempo.
 *
 * Los tres de fecha del core y, ademas, cualquier columna calculada cuyo
 * resultado sea una fecha: una formula, y con ella los lookup y rollup, que son
 * formulas por dentro y traen su tipo en `formula_type`.
 *
 * Tiene que coincidir con `es_campo_de_fecha` del backend
 * (views/kanban_view_type.py). Cuando no coincidian, el backend aceptaba una
 * fecha calculada pero el selector de la cabecera no la listaba, asi que la
 * vista se veia bien y su menu mostraba el hueco de "no hay nada elegido".
 */
const DE_FECHA = ['date', 'last_modified', 'created_on']

export function esCampoDeFecha(campo) {
  return (
    DE_FECHA.includes(campo.type) ||
    (campo.type === 'formula' && campo.formula_type === 'date') ||
    (campo.formula_type !== undefined && campo.formula_type === 'date')
  )
}

export function camposDeFecha(campos) {
  return campos.filter(esCampoDeFecha)
}
